import React from 'react';
import OpeningsPage from 'src/templates/CareersPageTemplate/OpeningsPage';
import { JOB_DATA, JOB_LOCATIONS, CmsComponents } from 'src/lib/constants';

import { generateJobsPaths, generateJobsProps } from 'src/lib/careers-utils';

const DepartmentLocationPage = ({ fields }) => {
  return <OpeningsPage fields={fields} />;
};

export async function getStaticPaths() {
  const jobDepartments = ['All Departments'].concat(Object.keys(JOB_DATA));
  const jobLocations = ['All Locations'].concat(JOB_LOCATIONS);

  return generateJobsPaths({ pathParams: { jobDepartments, jobLocations } });
}

export async function getStaticProps({ params, preview }) {
  let jobProps;
  try {
    jobProps = await generateJobsProps({
      params,
      dynamicSegments: ['department', 'location'],
      components: [CmsComponents.PAGE_HEADER],
      preview,
    });
  } catch (e) {
    throw new Error(e);
  }
  return jobProps;
}

export default DepartmentLocationPage;
